import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card, Typography } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import BankConnectService from '../admin-settings/bank-accounts/services';

const { Text, Title } = Typography;

// Self-contained brand promo surface (mirrors the mobile dashboard card): fixed dark-indigo
// background with white content, so it reads the same in light and dark themes.
const CARD_BG = '#1b125f';
const CARDS_IMAGE = 'https://cdn.gridbind.com/images/others/png/credit-cards/credit-cards-cards.png';

const OnlinePaymentPromo = () => {
  const [isOnlinePaymentEnabled, setIsOnlinePaymentEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkOnlinePaymentStatus();
  }, []);

  const checkOnlinePaymentStatus = () => {
    BankConnectService.getAccount()
      .then((res) => {
        try {
          let result = res.data;
          if (result.success && result.data) {
            const account = result.data;
            const isActive = account.status === 'active' && account.is_online_payment_active === true;
            setIsOnlinePaymentEnabled(isActive);
          } else {
            setIsOnlinePaymentEnabled(false);
          }
        } catch (error) {
          console.log('Error checking online payment status:', error);
          setIsOnlinePaymentEnabled(false);
        } finally {
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log('Error fetching bank connect account:', error);
        setIsOnlinePaymentEnabled(false);
        setLoading(false);
      });
  };

  // Don't show if online payment is already enabled or still loading
  if (loading || isOnlinePaymentEnabled) {
    return null;
  }

  return (
    <Link to="/bank-accounts" className="mb-3" style={{ display: 'block' }}>
      <Card
        hoverable
        styles={{ body: { padding: 0, background: 'transparent' } }}
        style={{ background: CARD_BG, border: 'none', borderRadius: 16, overflow: 'hidden' }}
      >
        <div style={{ position: 'relative', minHeight: 168 }}>
          {/* Big credit-cards artwork anchored to the bottom-right (bleeds slightly, clipped to the corner) */}
          <img
            src={CARDS_IMAGE}
            alt=""
            aria-hidden="true"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
            style={{
              position: 'absolute',
              right: -24,
              bottom: -40,
              width: 340,
              maxWidth: '48%',
              height: 'auto',
              objectFit: 'contain',
              pointerEvents: 'none',
              userSelect: 'none',
            }}
          />
          <div style={{ position: 'relative', padding: 24, maxWidth: 'min(62%, 480px)' }}>
            <Title level={4} style={{ color: '#ffffff', marginBottom: 8 }}>
              Accept Online Payments
            </Title>
            <Text style={{ color: 'rgba(255,255,255,0.85)', display: 'block', marginBottom: 16 }}>
              Enable online payments and let your customers pay invoices instantly with credit cards,
              debit cards, and other payment methods.
            </Text>
            <span
              style={{
                color: '#ffffff',
                fontWeight: 600,
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
              }}
            >
              Set up online payments <ArrowRightOutlined />
            </span>
          </div>
        </div>
      </Card>
    </Link>
  );
};

export default OnlinePaymentPromo;
